import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import '../../../../../../../styles/kp-11Generic-catalog-card.css'
import GenericKP11CardSelectInput from '../kp-11-generic-cards/kp11-generic-card-select-input'
import {getKeapKcpCertificationOptionsByCountry} from '../../../../../kp-shared-link/kp-sharedLink-utility/kp-utility'
import {
  buildCartEntity,
  countryCurrencyEnum,
} from '../../../../kp-11Link-utility/kp11-utility'
import {
  selectKP11SelectCartCentersNApps,
  selectedKeapKcpOption,
  setSelectedKeapKcpOption,
} from '../../../../../../../app-store/kp11CartSlice'

const KP11KeapKcpCertification = ({
  name,
  price,
  isChecked,
  groupKey,
  itemCode,
  selectedCountry,
  onAddToCart,
  item,
  section,
  billingType,
}) => {
  const dispatch = useDispatch()
  const [isExpanded, setIsExpanded] = useState(isChecked)
  const countryCurrency = countryCurrencyEnum[selectedCountry]
  const keapKcpOption = useSelector(selectedKeapKcpOption)
  const [selectedOptionValue, setSelectedOptionValue] = useState(keapKcpOption)
  const cartCentersAndApps = useSelector(selectKP11SelectCartCentersNApps)
  const oneTimeFee =
    cartCentersAndApps?.oneTimeFees?.map(item => item.code) || []

  useEffect(() => {
    setIsExpanded(isChecked)
  }, [isChecked])

  const allOptions = getKeapKcpCertificationOptionsByCountry(selectedCountry)

  const handleSelect = value => {
    setSelectedOptionValue(value)
    dispatch(setSelectedKeapKcpOption(value))
  }

  const handleSave = () => {
    if (!selectedOptionValue) {
      return
    }

    const updatedItem = buildCartEntity({
      kind: 'addon',
      source: {
        ...item,
        currencies: item.currencies.map(currencyInfo => {
          if (currencyInfo.currency === countryCurrency) {
            return {
              ...currencyInfo,
              unitAmount: parseFloat(selectedOptionValue.split('-')[1]).toFixed(
                2,
              ),
            }
          }
          return currencyInfo
        }),
        groupKey,
        section,
      },
    })

    onAddToCart(updatedItem, selectedOptionValue)
  }

  return (
    <GenericKP11CardSelectInput
      name={name}
      //price={priceValue}
      billingType={billingType}
      label="Select quantity"
      placeholder="Choose amount"
      groupKey={groupKey}
      itemCode={itemCode}
      isExpanded={isExpanded}
      value={selectedOptionValue}
      options={allOptions}
      onClick={() => {
        setIsExpanded(true)
      }}
      onSelect={handleSelect}
      onSave={handleSave}
      addToCartDisabled={
        oneTimeFee.includes('keap_kcc-cert-5-fee') ? true : false
      }
      selectedCountry={selectedCountry}
    />
  )
}

export default KP11KeapKcpCertification
